// @flow
import ContentConfigurationQuestions from "./ContentConfigurationQuestions";
import ContentConfigurationResults from "./ContentConfigurationResults";
import ContentConfigurationEndResults from "./ContentConfigurationEndResults";

/**
 * Content definition for questions, results, given answers etc.
 * Mostly maps to the Instrument questions configuration of Be Informed
 */
export default class ContentConfiguration {
  _config: Object;

  /**
   */
  constructor(contentConfiguration: Object) {
    this._config = contentConfiguration || null;
  }

  /**
   */
  get questions(): null | ContentConfigurationQuestions {
    if (this._config === null || !this._config.questions) {
      return null;
    }

    return new ContentConfigurationQuestions(this._config.questions);
  }

  /**
   */
  isConfiguredIntermediateResultAttribute(attributeKey: string): boolean {
    if (this.intermediateResults === null) {
      return false;
    }

    return this.intermediateResults.attributes.includes(attributeKey);
  }

  /**
   */
  get intermediateResults(): null | ContentConfigurationResults {
    if (this._config === null || !this._config.intermediateResults) {
      return null;
    }

    return new ContentConfigurationResults(this._config.intermediateResults);
  }

  /**
   */
  isConfiguredEndResultAttribute(attributeKey: string): boolean {
    if (this.endResults === null) {
      return false;
    }

    return this.endResults.config.some((item) =>
      item.attributes.includes(attributeKey),
    );
  }

  /**
   */
  get endResults(): null | ContentConfigurationEndResults {
    if (this._config === null || !this._config.results) {
      return null;
    }

    return new ContentConfigurationEndResults(this._config.results);
  }
}
